import styles from './cartListItem.module.css';

const CartListItem = ({ cartItem, addProductInCart, removeProductFromCart, deletePurchasedProduct }) => {
    const { name, url, count, totalPrice, id } = cartItem;

    // console.log(count, name)
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>
                    <img src={url} alt="Телефон" className={styles.image} />
                </div>
                <h4 className={styles.name}>{name}</h4>
            </div>
            

                <div className={styles.countContainer}>
                    <button className={styles.minus} onClick={() => removeProductFromCart(id)}>-</button>
                    <span className={styles.count}>{count} шт</span>
                    <button className={styles.plus} onClick={() => addProductInCart(id)}>+</button>
                    
                </div>

                <div>
                    <span className={styles.totalPrice}>{totalPrice} грн</span>
                    <button className={styles.delete}
                            onClick={() => deletePurchasedProduct(id)}>Видалити</button>
                </div>
            

        </div>
    )
};

export default CartListItem;
